import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { ApexField as ApexField$1 } from '@zillow/zrs-cms';

var BlockApexField = function BlockApexField(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  // Users may add an ApexField in the editor, without picking a type. So don't
  // render these otherwise it crashes frontend.
  if (!attrs.formData) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ApexField$1, _extends({
    key: index
  }, attrs));
};
BlockApexField.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
} : {};
var ApexField = BlockApexField;

export { ApexField as default };
